import styles from "../../Styles/Icon.module.css";
const Icon = ({ name, image }) => {
  return (
    <div className={styles.icon}>
      <img className={styles.icon__img} alt={name} src={image} />
    </div>
  );
};
export default Icon;
